import React from "react";

export const UploadIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M4.00008 22.04H6.98004V25H25.02V22.04H27.9943L28 28H4L4.00008 22.04Z"
            fill="currentColor"
        />
        <path
            d="M18.0983 4L17.0452 5.07814L16.0008 6.15182L13.9032 4L6.54004 11.5485L8.64339 13.7048L16.0008 6.15182L23.3567 13.7048L25.46 11.5485L18.0983 4Z"
            fill="currentColor"
        />
        <path
            d="M17.4917 22.92H14.5168V9.19601H17.4917V22.92Z"
            fill="currentColor"
        />
    </svg>
);
